export default {
  mainBannerData: (state) => state.mainBanner || {},
  mainBRKData: (state) => state.mainBRK || {},
  mainTodayData: (state) => state.mainToday || {},
};
